import { Component, Input } from '@angular/core';
import { RfqSessionSupplier } from 'src/app/shared/models';

@Component({
	selector: 'pk-broker-pricing-session-supplier-notes',
	standalone: false,
	templateUrl: './pricing-session-supplier-notes.component.html',
	styleUrl: './pricing-session-supplier-notes.component.scss',
})
export class PricingSessionSupplierNotesComponent {
	@Input() rfqSessionSuppliers: RfqSessionSupplier[] = [];

	public view: 'view' | 'add-edit' = 'view';
	public editRfqSessionSupplier: RfqSessionSupplier;
	public editNoteKey: string;

	public editNote({ rfqSessionSupplier, noteKey }: { rfqSessionSupplier: RfqSessionSupplier; noteKey: string }) {
		this.editRfqSessionSupplier = rfqSessionSupplier;
		this.editNoteKey = noteKey;
		this.view = 'add-edit';
	}

	public backToNotes() {
		this.view = 'view';
		this.editRfqSessionSupplier = undefined;
		this.editNoteKey = undefined;
	}
}
